#
#  The chat class
#
class window.Chat
    constructor: (@selector, @roomId, @gameId = null, isTeamChat = false) ->
        self = this

        # Send new messages
        $("#{@selector} form").submit(() ->
            self.sendChat($("#{self.selector} .body").val())
            return false
        )

        # Toggle chat moderate mode
        unless isTeamChat
            $('.moderate-chat-link').click(() ->
                icon = $('.moderate-chat-link').find('i')

                if icon.is('.fa-comments-o')
                    # Enable moderation mode
                    icon.removeClass('fa-comments-o').addClass('fa-comments')
                    self.showHideChatModeration(true)
                else
                    # Disable moderation mode
                    icon.removeClass('fa-comments').addClass('fa-comments-o')
                    self.showHideChatModeration(false)

                return false
            )

        # Init the update loop and scroll down the existing chatlines
        @resetInterval()
        @initializeChatControls()
        if $(@selector).is(':visible')
            @scrollBottom()
        else
            tabLinkSelector = @selector.substr(0, @selector.indexOf(' ')) + '-tab-link'
            $(tabLinkSelector).one('click', () -> self.scrollBottom())

    initializeChatControls: (parentIdentifier = '') ->
        # Unbind all the current click handlers, because I don't want doubles
        $("#{parentIdentifier} .chat-delete").unbind('click')
        $("#{parentIdentifier} .chat-restore").unbind('click')

        # Bind the new click handlers
        $("#{parentIdentifier} .chat-delete").click(() ->
            $(this).find('i.fa-times').removeClass('fa-times').addClass('fa-times-circle')
            $.ajax({
                url: "#{baseurl}/chat/#{$(this).data('id')}/delete"
                method: 'POST'
                data: {
                    _token: csrftoken
                }
                success: null
                error: (jqXHR, textStatus, errorThrown) ->
                    alert("data: #{JSON.stringify(jqXHR, null, 4)}, status: #{textStatus}, error: #{errorThrown}")
            })
            return false
        )
        $("#{parentIdentifier} .chat-restore").click(() ->
            $(this).find('i.fa-plus').removeClass('fa-plus').addClass('fa-plus-circle')
            $.ajax({
                url: "#{baseurl}/chat/#{$(this).data('id')}/restore"
                method: 'POST'
                data: {
                    _token: csrftoken
                }
                success: null
                error: (jqXHR, textStatus, errorThrown) ->
                    alert("data: #{JSON.stringify(jqXHR, null, 4)}, status: #{textStatus}, error: #{errorThrown}")
            })
            return false
        )

    showHideChatModeration: (visibility) ->
        $('.chat-messages .trashed').toggle(visibility)
        $('.chat-controls').toggle(visibility)

    sendChat: (message) ->
        $("#{@selector} form button").prop('disabled', true)

        $.ajax({
            url: "#{baseurl}/chat/send"
            method: 'POST'
            data: {
                _token: csrftoken
                body: message
                room_id: @roomId
                game_id: @gameId
            }
            success: @afterSendChat
            error: (jqXHR, textStatus, errorThrown) =>
                $("#{@selector} form button").prop('disabled', false)
                $("#{@selector} form").addClass('form-error')
                # alert("data: #{JSON.stringify(jqXHR, null, 4)}, status: #{textStatus}, error: #{errorThrown}")
        })

    scrollBottom: () ->
        ul = $("#{@selector} .chat-messages")
        ul.scrollTop(ul.prop('scrollHeight'))

    # Note the fat arrow
    afterSendChat: () =>
        $("#{@selector} form input.body").val('')
        $("#{@selector} form button").prop('disabled', false)
        $("#{@selector} form").removeClass('form-error')
        @update()
        @resetInterval()
        @updating = true

    # The update loop
    # Note the fat arrow
    update: () =>
        $("#{@selector} form").removeClass('form-error')
        if @updating or not activity.wasLastActivityWithin(activity.longActivityThreshold) or
                (not @isOddUpdate and not activity.wasLastActivityWithin(activity.activityThreshold))
            return
        @updating = true
        @isOddUpdate = not @isOddUpdate

        $.ajax({
            url: "#{baseurl}/chat"
            method: 'POST'
            data: {
                _token: csrftoken
                last_updated: $("#{@selector} .last_updated").val()
                room_id: @roomId
                game_id: @gameId
            }
            # Note the fat arrow to ensure 'this' is set correctly
            success: (result) =>
                @updating = false
                newChatLines = false
                if (result.lines?)
                    for line in result.lines
                        # If the chatline already exists, update it
                        lineId = $(line).attr('id')
                        lineEl = $("##{lineId}")
                        if lineEl.length > 0
                            lineEl.replaceWith(line)
                        # Otherwise append it at the bottom
                        else
                            $("#{@selector} .chat-messages").append(line)
                            newChatLines = true
                    if $('.moderate-chat-link i').is('.fa-comments')
                        @showHideChatModeration(true)
                    $("#{@selector} .last_updated").val(result.last_updated)
                    if newChatLines
                        @scrollBottom()
                @initializeChatControls()
            # Note the fat arrow to ensure 'this' is set correctly
            error: (jqXHR, textStatus, errorThrown) =>
                @updating = false
        })

    resetInterval: () ->
        @isOddUpdate = true
        @updating = false
        clearInterval(@updateLoop)
        @updateLoop = setInterval(@update, 10000)
